import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" data-testid="app-error" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a", color: "#fff", fontFamily: "system-ui, sans-serif", padding: "2rem" }}>
          <div style={{ textAlign: "center", maxWidth: "400px" }}>
            <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>Shylov Cleaning</h1>
            <p style={{ color: "#94a3b8", marginBottom: "1.5rem" }}>
              Something went wrong. Please refresh the page.
            </p>
            <button
              data-testid="app-error-reload"
              onClick={() => window.location.reload()}
              style={{ background: "#0891b2", color: "#fff", border: "none", padding: "0.75rem 2rem", cursor: "pointer", fontSize: "1rem" }}
            >
              Refresh
            </button>
            <p style={{ color: "#64748b", marginTop: "1.5rem", fontSize: "0.875rem" }}>
              +33 7 56 88 88 21
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
